import { combineReducers } from 'redux';
import activeHouseholdId from './activeHouseholdIdReducer';
import activeTab from './tabReducer';
import ctaType from './ctaReducer';
import dashboardModels from './dashboardModelsReducer';

export default combineReducers({
    activeHouseholdId,
    activeTab,
    ctaType,
    dashboardModels
});
